// Autogenerated file
export const shippingOrderTitleStatusesEnum = {
    ReceivedOrCreated: "ReceivedOrCreated",
    Signed: "Signed",
};
export const shippingOrderTitleStatuses = [
    { label: "Создан", value: "ReceivedOrCreated" },
    { label: "Подписан", value: "Signed" },
];
